import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Form, Spinner, Row, Col, Button } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import PageTitle from 'src/components/general/PageTitle';
import { HOLIDAY_LIST } from 'src/utils/constants';
import { getHolidayCreateIsFetching, getHolidayTypeListIsFetching } from 'src/redux/holiday/holidayReducer';
import { tryAddNewHoliday } from 'src/redux/holiday/holidayActionCreator';
import HolidayForm from '../../forms/Holiday/HolidayForm';
import AppLoading from 'src/components/common/AppLoading';

const HolidayNewPage = () => {

	const dispatch = useDispatch();

	const hookFormMethods = useForm();
	const { handleSubmit } = hookFormMethods;

	const createHolidayIsFetching = useSelector(state => getHolidayCreateIsFetching(state));
	const holidayTypeListIsFetching = useSelector(state => getHolidayTypeListIsFetching(state));

	const onFormSubmit = data => {
		const date = data?.year;
		const name = data?.name;
		const typeId = data?.typeId;

		const params = {
			date: date,
			name: name,
			holidayType: {"id": typeId}
		};

		dispatch(tryAddNewHoliday(params));
	};

	return <Container fluid className='mb-5'>
		<Card>
			<PageTitle text='Feriado' />
			<Container fluid>
				<Card className='mb-3'>
					<Card.Header>
						<h6 className='mb-0'>Nuevo Feriado</h6>
					</Card.Header>
					<Card.Body >
						<Row>
							<Col xs={8}>
								<h6 className='mb-4 text-black-color'>
								</h6>
							</Col>
							<Col xs={4} className='text-right font-weight-bold font-italic'>
								<span className='text-danger d-flex mandatory-label'>
									<FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									Requerido
								</span>
							</Col>
						</Row>
						<FormProvider {...hookFormMethods} >
							<Form onSubmit={handleSubmit(onFormSubmit)} autoComplete='off'>

								<HolidayForm />

								<div className='d-flex justify-content-around mt-4 mb-3'>
									<Button
										variant='danger'
										size='lg'
										disabled={createHolidayIsFetching}
										onClick={() => dispatch(push(HOLIDAY_LIST))}
									>
										Cancelar
									</Button>

									<Button
										type='submit'
										variant='success'
										size='lg'
										disabled={createHolidayIsFetching || holidayTypeListIsFetching}
									>
										Guardar
									</Button>
								</div>
							</Form>
						</FormProvider>
					</Card.Body>
				</Card>
			</Container>
		</Card>
		<AppLoading isLoading={createHolidayIsFetching} />
	</Container>;
};

export default HolidayNewPage;